<template>
  <v-container fluid class="px-0">
    <div class="profile-page">

    </div>
  </v-container>
</template>

<script>
import config from "@/config"

export default {
  name: 'Profile',

  data() {
    return {
      config,
    }
  },
  methods: {

  },
  mounted() {

  }
}
</script>

<style src="./Profile.scss" lang="scss"/>
